module.exports = __webpack_public_path__ + "static/img/giz-logo.aa70858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/giz-logo.png
// module id = 2nfX
// module chunks = 1